import { render } from "./query-exam.vue?vue&type=template&id=3f5e28ae"
import script from "./query-exam.vue?vue&type=script&lang=js"
export * from "./query-exam.vue?vue&type=script&lang=js"

import "./query-exam.vue?vue&type=style&index=0&id=3f5e28ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__